import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api.service';
import { Observable } from 'rxjs/internal/Observable';

@Injectable({
    providedIn: 'root',
})
export class TechIntelApiService {
    private readonly url: string = 'service/contactcloud/techIntel';

    constructor(private readonly baseApiService: BaseApiService) { }

    getExportCrmSettings(crmName: string): Observable<any> {
        return this.baseApiService.get(`${this.url}/crm/settings`, { params: { crmName } });
    }

    saveExportCrmSettings(type: string, settings): Observable<any> {
        return this.baseApiService.put(`${this.url}/crm/settings?crmName=` + type, settings);
    }
}
